import { render, staticRenderFns } from "./SportelloContrattiDaVisionareView.vue?vue&type=template&id=0e401452&"
import script from "./SportelloContrattiDaVisionareView.vue?vue&type=script&lang=ts&"
export * from "./SportelloContrattiDaVisionareView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports